import { AsyncDataProvider, cacheStoragePrefixAmaxPayPaymentDetails } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { memo, useCallback } from 'react';
import { useGetXeroCounterpartyPaymentDetailsForRequest } from 'shared/data/webApp/v1';

import { PaymentDetailsDataProviderProps } from './PaymentDetailsDataProvider.types';

export const PaymentDetailsDataProvider = memo<PaymentDetailsDataProviderProps>((props) => {
    const { children, counterpartyId } = props;

    const { id: requestId, companyId } = useSelector(getRequest);

    const { refetch } = useGetXeroCounterpartyPaymentDetailsForRequest(
        {
            path: {
                companyId,
                requestId,
                counterpartyId,
            },
        },
        {
            enabled: false,
        }
    );

    const onLoad = useCallback(async () => {
        const { data } = await refetch();

        return (
            data?.items.map((item) => ({
                text: item.bankAccount.name,
                ...item,
            })) || []
        );
    }, [refetch]);

    return (
        <AsyncDataProvider
            cacheStorageId={`${cacheStoragePrefixAmaxPayPaymentDetails}${requestId}.${counterpartyId}`}
            pageSize={100}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
});

PaymentDetailsDataProvider.displayName = 'PaymentDetailsDataProvider';
